/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Step_DetailsInputs */

const en_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const es_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalles`)
};

const de_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einzelheiten`)
};

const zh_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`详细信息`)
};

const ar_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التفاصيل`)
};

const fr_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails`)
};

const vi_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi tiết`)
};

const sw_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maelezo`)
};

const th_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายละเอียด`)
};

const bs_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalji`)
};

const ja_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細`)
};

const ko_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정보`)
};

const pt_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalhes`)
};

const it_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dettagli`)
};

const sv_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detaljer`)
};

const nl_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegevens`)
};

const da_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detaljer`)
};

const nb_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detaljer`)
};

const fi_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yksityiskohdat`)
};

const pl_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szczegóły`)
};

const ru_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подробности`)
};

const tr_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detaylar`)
};

const hi_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण`)
};

const id_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rincian`)
};

const ms_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perincian`)
};

const cs_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podrobnosti`)
};

const el_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Λεπτομέρειες`)
};

const he_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פרטים`)
};

const af_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besonderhede`)
};

const hu_booking_step_details = /** @type {(inputs: Booking_Step_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adatok`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Booking_Step_DetailsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_step_details = /** @type {((inputs?: Booking_Step_DetailsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Step_DetailsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_step_details(inputs)
	if (locale === "de") return de_booking_step_details(inputs)
	if (locale === "zh") return zh_booking_step_details(inputs)
	if (locale === "ar") return ar_booking_step_details(inputs)
	if (locale === "fr") return fr_booking_step_details(inputs)
	if (locale === "vi") return vi_booking_step_details(inputs)
	if (locale === "sw") return sw_booking_step_details(inputs)
	if (locale === "th") return th_booking_step_details(inputs)
	if (locale === "bs") return bs_booking_step_details(inputs)
	if (locale === "ja") return ja_booking_step_details(inputs)
	if (locale === "ko") return ko_booking_step_details(inputs)
	if (locale === "pt") return pt_booking_step_details(inputs)
	if (locale === "it") return it_booking_step_details(inputs)
	if (locale === "sv") return sv_booking_step_details(inputs)
	if (locale === "nl") return nl_booking_step_details(inputs)
	if (locale === "da") return da_booking_step_details(inputs)
	if (locale === "nb") return nb_booking_step_details(inputs)
	if (locale === "fi") return fi_booking_step_details(inputs)
	if (locale === "pl") return pl_booking_step_details(inputs)
	if (locale === "ru") return ru_booking_step_details(inputs)
	if (locale === "tr") return tr_booking_step_details(inputs)
	if (locale === "hi") return hi_booking_step_details(inputs)
	if (locale === "id") return id_booking_step_details(inputs)
	if (locale === "ms") return ms_booking_step_details(inputs)
	if (locale === "cs") return cs_booking_step_details(inputs)
	if (locale === "el") return el_booking_step_details(inputs)
	if (locale === "he") return he_booking_step_details(inputs)
	if (locale === "af") return af_booking_step_details(inputs)
	if (locale === "hu") return hu_booking_step_details(inputs)
	return en_booking_step_details(inputs)
});